import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["checked", "defaultChecked", "description", "disabled", "label", "onChange", "size"];
import React, { forwardRef } from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MuiSwitch from '@mui/material/Switch';
import { useTheme } from '@mui/material/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Switch = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    _props$defaultChecked = props.defaultChecked,
    defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked,
    description = props.description,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    label = props.label,
    onChange = props.onChange,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    others = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(Stack, {
    alignItems: "flex-start",
    direction: "row",
    spacing: size === 'small' ? 2 : 3,
    children: [/*#__PURE__*/_jsx(MuiSwitch, _extends({
      checked: defaultChecked || checked,
      disabled: disabled,
      onChange: onChange,
      size: size
    }, others)), (label || description) && /*#__PURE__*/_jsxs(Stack, {
      gap: 0.25,
      children: [/*#__PURE__*/_jsx(Typography, {
        color: theme.palette.gray[700],
        variant: size === 'small' ? 'text-sm-medium' : 'text-md-medium',
        children: label
      }), description && /*#__PURE__*/_jsx(Typography, {
        color: theme.palette.gray[600],
        variant: size === 'small' ? 'text-sm-regular' : 'text-md-regular',
        children: description
      })]
    })]
  });
});